<footer>&copy; 2004-{{pageDate | date: 'yyyy'}} Eldon L. Lewis</footer>